"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledEmptyDataSecond = exports.StyledEmptyDataFirst = exports.StyledEmptyDataIcon = exports.StyledEmptyData = exports.StyledGridBodyCellMultiple = exports.StyledGridBodyRowMultiple = exports.StyledGridBodyCellText = exports.StyledGridBodyCell = exports.StyledGridBodyRow = exports.StyledGridBody = exports.StyledGridHeaderColumnSortIcon = exports.StyledGridHeaderColumnText = exports.StyledGridHeaderColumn = exports.StyledGridHeader = exports.StyledGrid = exports.Skeleton = void 0;

const styled_components_1 = __importStar(require("styled-components"));

const react_loading_skeleton_1 = __importDefault(require("react-loading-skeleton"));

const rowHeight = '60px';
exports.Skeleton = (0, styled_components_1.default)(react_loading_skeleton_1.default)`
  @keyframes react-loading-skeleton {
    100% {
      transform: translateX(100%);
    }
  }

  & {
    --base-color: #ebebeb;
    --highlight-color: #f5f5f5;
    --animation-duration: 1.5s;
    --animation-direction: normal;
    --pseudo-element-display: block; /* Enable animation */

    background-color: var(--base-color);

    width: 100%;
    border-radius: 0.25rem;
    display: inline-flex;
    line-height: 1;

    position: relative;
    overflow: hidden;
    z-index: 1; /* Necessary for overflow: hidden to work correctly in Safari */
  }

  &::after {
    content: ' ';
    display: var(--pseudo-element-display);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-repeat: no-repeat;
    background-image: linear-gradient(
      90deg,
      var(--base-color),
      var(--highlight-color),
      var(--base-color)
    );
    transform: translateX(-100%);
    animation-name: react-loading-skeleton;
    animation-direction: var(--animation-direction);
    animation-duration: var(--animation-duration);
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }
`;
exports.StyledGrid = styled_components_1.default.div`
  position: relative;
  top: ${props => {
  var _props$top;

  return props.stickyHeader ? (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : '0' : 'initial';
}};

  background-color: ${props => props.bgColor || props.theme.colors.beige_100};
  font-family: 'Roboto', sans-serif;
  font-size: ${props => props.theme.fontSizes[14]};

  & * {
    box-sizing: border-box;
  }
`;
exports.StyledGridHeader = styled_components_1.default.div`
  height: ${rowHeight};
  position: ${props => props.stickyHeader ? 'sticky' : 'initial'};
  top: ${props => {
  var _props$top2;

  return props.stickyHeader ? (_props$top2 = props.top) !== null && _props$top2 !== void 0 ? _props$top2 : '0' : 'initial';
}};
  background-color: ${props => props.bgColor || props.theme.colors.beige_100};
  display: grid;
  grid-template-columns: ${props => props.gridTemplateColumns};
  margin: 0;
  padding: 0;
  box-shadow: 5px 0 0 0 ${props => props.bgColor || props.theme.colors.beige_100},
    -5px 0 0 0 ${props => props.bgColor || props.theme.colors.beige_100};
  border: 1px solid ${props => props.theme.colors.beige_100};
  z-index: 1;
  width: fit-content;
  min-width: 100%;
`;
exports.StyledGridHeaderColumn = styled_components_1.default.div`
  color: ${props => props.theme.colors.black_main};
  display: inline-flex;
  align-items: center;
  cursor: ${props => props.sortable ? 'pointer' : 'default'};
  white-space: nowrap;
  padding: 0 0 0 20px;
  margin: 0;
  line-height: 14px;
  font-weight: 500;
  box-sizing: border-box;
  height: ${rowHeight};
  ${props => props.stylesOverride};
`;
exports.StyledGridHeaderColumnText = styled_components_1.default.span`
  display: inline-block;
  white-space: nowrap;
`;
exports.StyledGridHeaderColumnSortIcon = styled_components_1.default.span`
  display: inline-flex;
  align-items: center;
  height: 14px;
`;
exports.StyledGridBody = styled_components_1.default.div`
  background-color: ${props => props.bgColor || props.theme.colors.beige_100};
  margin-top: 1px;
`;
exports.StyledGridBodyRow = styled_components_1.default.div`
  position: relative;
  display: grid;
  grid-template-columns: ${props => props.gridTemplateColumns};
  height: ${rowHeight};
  border: 1px solid
    ${props => props.active ? props.theme.colors.primary_700_main : props.theme.colors.gray_201};
  border-radius: 4px;
  margin: 0 0 ${props => props.multiple ? 0 : '12px'};
  background-color: ${props => props.active ? props.theme.colors.beige_200 : props.theme.colors.white};

  width: fit-content;
  min-width: 100%;

  ${props => !props.$loading && !props.active && (0, styled_components_1.css)`
      &:hover {
        transition: 0.4s all;
        box-shadow: 0 3px 5px #00000026;
        border: 1px solid ${props.theme.colors.gray_302};
        cursor: pointer;
      }
    `};
`;
exports.StyledGridBodyCell = styled_components_1.default.div`
  padding: 0 0 0 20px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  height: ${rowHeight};
  line-height: 19px;
  font-weight: 400;
  color: ${props => props.theme.colors.black_main};
  min-width: 0;

  &:last-child {
    padding-right: 20px;
  }
`;
exports.StyledGridBodyCellText = styled_components_1.default.span`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;
exports.StyledGridBodyRowMultiple = styled_components_1.default.div`
  display: grid;
  grid-template-columns: 100%;
  height: 5px;
  margin-bottom: 12px;
  padding: 0 5px;
  width: fit-content;
  min-width: 100%;
`;
exports.StyledGridBodyCellMultiple = styled_components_1.default.div`
  display: block;
  background-color: ${props => props.theme.colors.white};
  border-color: ${props => props.theme.colors.gray_201};
  border-style: solid;
  border-left-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-top-width: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;
exports.StyledEmptyData = styled_components_1.default.div`
  background-color: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 66px 0 56px;
  color: ${props => props.theme.colors.black_main};
  margin: 0 4px;
  border: 1px dashed ${props => props.theme.colors.beige_400};
  border-radius: 4px;

  & a {
    color: #2d5dec;
  }
`;
exports.StyledEmptyDataIcon = styled_components_1.default.div`
  margin-bottom: 22px;
  text-align: center;
`;
exports.StyledEmptyDataFirst = styled_components_1.default.div`
  font-weight: 500;
  font-size: 26px;
  line-height: 34px;
  margin-bottom: 10px;
`;
exports.StyledEmptyDataSecond = styled_components_1.default.div`
  font-size: 18px;
  line-height: 24px;
  text-align: center;
`;